import * as React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { locales } from './constants/locales';
import Home from './pages/home';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to={`/${locales.defaultLanguageCode}/`} /> } exact />
        <Route path="/:locale/" element={<Home />} />
      </Routes>
    </Router>
  );
}
